import script from "./ModalDeBusca.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDeBusca.vue?vue&type=script&setup=true&lang=js"

import "./ModalDeBusca.vue?vue&type=style&index=0&id=a7dd96b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7dd96b4"]])

export default __exports__